import React, { useEffect, useState, forwardRef } from "react";
import { useLocation } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import "./addEval.css";
import iconcalendarColor from "../../../assets/images/icon-calendar.svg";

import DatePicker from "react-datepicker";
import {
  Form,
  InputGroup,
} from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import alice from "../../../assets/images/alice.jpg";

import fr from "date-fns/locale/fr";
import "react-datepicker/dist/react-datepicker.css";
import {
  HandelGrille,
  getOneGrilles,
  AllGrids,
} from "../../../redux/actions/grille";
import { getAttributsGrid } from "../../../redux/actions/attribut";
import { getAllClients } from "../../../redux/actions/user";
// registerLocale('fr', fr);
import { useFormik, Formik } from "formik";
import * as Yup from "yup";

const LeftSide = (props) => {

/*   const formik=useFormik({
    enableReinitialize: true,
    validationSchema: Yup.object({
      
      agent: Yup.string().required("L'agent est obligatoire"), // Add validation for agent field
    }),
    onSubmit: (formValues) => {
 
    },
  }) */
  const user = JSON.parse(localStorage.getItem("user"));

  const [startDate, setStartDate] = useState(null);
  const [isCanal, setIsCanal] = useState(false);
  const [isNorme, setIsNorme] = useState(false);
  const [isMotif, setIsMotif] = useState(false);

  const [isEmail, setIsEmail] = useState(false);
  const [isChat, setIsChat] = useState(false);
  const [isAgence, setIsAgence] = useState(false);
  const { dataevals, dataeval } = useSelector((state) => state.evaluation);
  const { datagrilles, datagrille , listGrids} = useSelector((state) => state.grille);
  const { attributs } = useSelector((state) => state.attribut);
  const { clients, client } = useSelector((state) => state.user);
  const location = useLocation();
  const dup = location?.state?.dup;
  const [ListAttributs, setListAttributs] = useState([]);
  const [agents, setagents] = useState([]);
  const [grille, setgrille] = useState("");
  const [agent, setagent] = useState("");
  const [GridAttributs, setGridAttributs] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [value, setValue] = useState();
  const [visibleOptions, setVisibleOptions] = useState(value?.slice(0, 1));
  const [hiddenOptions, setHiddenOptions] = useState(
    value?.slice(1, value.length - 1)
  );
  let hiddenopt = [];

  const dispatch = useDispatch();

  useEffect(() => {
    fetchdata();
    setagents(clients.map((e) => e.firstName));

    if (dup) {
      dispatch(
        HandelGrille(
          datagrilles?.grids.filter(
            (grid) => grid.id === dataeval.eval.gridId
          )[0]
        )
      );
      delete dataeval.eval.id;
      delete dataeval.eval.evaluateurId;
      delete dataeval.eval.evaluateur;

      dataeval.eval.DetailEval.map((e) => delete e.id);
      dataeval.eval.DetailEval.map((e) => delete e.evaluationId);
      dataeval.eval.DetailEval.map((e) => delete e.EvaluationId);
      dataeval.eval.DetailEval.map((e) => delete e.Criteria.id);
      dataeval.eval.DetailEval.map((e) => delete e.Criteria.CriteriaGroupId);
      dataeval.eval.DetailEval.map((e) => delete e.Criteria.CriteriaGroup.id);
      dataeval.eval.DetailEval.map(
        (e) => delete e.Criteria.CriteriaGroup.gridId
      );
      dataeval.eval.DetailEval.map(
        (e) => delete e.Criteria.CriteriaGroup.GridId
      );
      dataeval.eval.DetailEval.map((e) =>
        e.Criteria.CriteriaGroup.Criteria.map((e) => delete e.id)
      );
      dataeval.eval.DetailEval.map((e) =>
        e.Criteria.CriteriaGroup.Criteria.map((e) =>
          e.CriteriaValue.map((e) => delete e.id)
        )
      );
      delete dataeval.eval.agent;
      delete dataeval.eval.Grid.id;
      delete dataeval.eval.Grid.id;

      setIsCanal(false);
      setIsNorme(false);
      setIsMotif(false);
      if (
        dataeval?.eval?.Grid?.gridAttributes &&
        dataeval?.eval?.Grid?.gridAttributes.map((e) => e.name === "Canal")[0]
      ) {
        setIsCanal(true);
      }

      if (
        dataeval?.eval?.Grid?.gridAttributes &&
        dataeval?.eval?.Grid?.gridAttributes.map((e) => e.name === "Norme")[0]
      ) {
        setIsNorme(true);
      }

      if (
        dataeval?.eval?.Grid?.gridAttributes &&
        dataeval?.eval?.Grid?.gridAttributes.map((e) => e.name === "Motif")[0]
      ) {
        setIsMotif(true);
      }
    }
  }, []);

  useEffect(() => {
    dispatch(HandelGrille(datagrille));
    props.handelChangegrilletId(datagrille?.id);
  }, [dataeval]);

  useEffect(()=>{
    dispatch(HandelGrille(datagrille));
  },[datagrille])

  useEffect(() => {
    setGridAttributs(
      attributs.map((attribut) => {
        const values = value?.find((v) => v.attributId === attribut.id);
        return {
          ...attribut,
          selectedValues: values ? [values] : [],
        };
      })
    );
    setListAttributs(attributs);
  }, [attributs]);

  const fetchdata = () => {
    dispatch(getAllClients(0, 100));
    dispatch(AllGrids(user?.TenantId));

   // dispatch(getGrillesByTenant(user?.TenantId, 0, 10));
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    props.handelChangeattributId(ListAttributs);
  }, [ListAttributs]);

  const handleSelectedValuesChange = async (selectedOptions, AttributId) => {
    var listValeurAttribut = [];
    var ValeurAttributs = [];

    if (selectedOptions.length > 2) {
      
      setVisibleOptions(selectedOptions.slice(0, 2));
      setHiddenOptions(selectedOptions.slice(2));
    } else {
      setVisibleOptions(selectedOptions);
      setHiddenOptions([]);
    }
    setValue(selectedOptions);

    //to make the selected options draggable with the attribut
    const newValues = selectedOptions.map((option) => ({
      value: option.value,
      label: option.label,
      attributId: AttributId,
    }));

    setGridAttributs((prevAttributs) =>
      prevAttributs.map((attribut) => {
        if (attribut.id === AttributId) {
          return {
            ...attribut,
            selectedValues: newValues,
          };
        } else {
          return attribut;
        }
      })
    );
    ///////////////////////////////////////////////
    await selectedOptions.map((options) => {
      if (!listValeurAttribut.includes(options.value)) {
        return listValeurAttribut.push(options.value);
      }
    });

    const result = await ListAttributs?.map((previousAttribut) => {
      if (AttributId == previousAttribut.id) {
        previousAttribut.ValeurAttribut.map((val) => {
          if (listValeurAttribut.includes(val.id)) {
            ValeurAttributs.push(val);
          }
          previousAttribut["SelectedValeurAttribut"] = ValeurAttributs;
          return previousAttribut;
        });
      }
      return previousAttribut;
    });

    setListAttributs(result);
  };

  const formatOptionLabel = (option) => {
    if (visibleOptions?.includes(option)) {
      return (
        <div>
          <span key={option.value}>{option.label}</span>
        </div>
      );
    } else {
      if (hiddenOptions?.includes(option)) {
        hiddenopt.push([...hiddenopt.filter((op) => op !== option), option]);
        return (
          <>
            {!expanded && hiddenopt.length ==1 &&  (
              <span style={{ cursor: "pointer" }} onClick={handleExpandClick}>
                ...
              </span>
            )}
            {expanded && (
              <div
                style={{
                  maxHeight: "200px", // set the maximum height
                  overflowY: "scroll", // enable vertical scrolling
                }}
              >
                <div key={option.value} onClick={handleExpandClick}>
                  {option.label}
                </div>
              </div>
            )}
          </>
        );
      } else {
        return <div key={option.value}>{option.label}</div>;
      }
    }
  };

  /*Drag and Drop Fonctionality*/
  const onDragEnd = (result) => {
    // Checks if the drop was successful and the item wasn't dropped in the same place
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    // Reorder the items in the state array
    const items = reorder(
      GridAttributs,
      result.source.index,
      result.destination.index
    );
    // Update the state with the new array of items
    //setGridAttributs(items);
    setGridAttributs(
      items.map((attribut, index) => ({
        ...attribut,
        selectedValues: attribut.selectedValues.map((value) => ({
          ...value,
          attributId: items[index].id,
        })),
      }))
    );
  };

  function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  const normeOptions = [
    {
      value: "Epic",
      label: "Epic",
    },
    {
      value: "ESCADA",
      label: "ESCADA",
    },
    {
      value: "Norme Nif",
      label: "Norme Nif",
    },
    {
      value: "Sans",
      label: "Sans",
    },
  ];

  const motifOptions = [
    {
      value: "Augmentation tarifaire",
      label: "Augmentation tarifaire",
    },
    {
      value: "Contestation",
      label: "Contestation",
    },
    {
      value: "Demande d'info",
      label: "Demande d'info",
    },
    {
      value: "Facturation",
      label: "Facturation",
    },
    {
      value: "Résiliation",
      label: "Résiliation",
    },
  ];
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <InputGroup onClick={onClick}>
      <Form.Control
        style={{ borderRadius: "5px" }}
        placeholder={
          dup
            ? new Date(dataeval?.eval?.dateInteraction).toLocaleDateString()
            : "Choisir la date d'interaction"
        }
        defaultValue={value}
        ref={ref}
      />
      <div className="search-icon">
        <img src={iconcalendarColor} />
      </div>
    </InputGroup>
  ));

  const selectStyles = {
    menuList: (styles) => {
      return {
        ...styles,
        maxHeight: 170,
      };
    },
  };

  return (
    <div>
      <div className="side-bar-eval">
        {/* --------------Détails de l'évaluation----------------- */}
       {/*  <form onSubmit={formik.handleSubmit}> */}
        <div className="vertical-items">
          <span className="left-side_title">Détails de l'évaluation</span>

          {/* ---------------grille---------------- */}
          <div>
            <Select
              className="basic-single"
              classNamePrefix="select"
              placeholder={
                datagrille?.grid?.name ? datagrille?.grid?.name : "Choisir une grille"
              }
              defaultValue={dup ? dataeval?.eval?.Grid?.name : datagrille?.grid?.name}
              isDisabled={false}
              isLoading={false}
              styles={selectStyles}
              isRtl={false}
              isSearchable={true}
              name="color"
              options={listGrids?.grids}
              getOptionValue={(datagrille) => datagrille.name}
              onChange={(defaultValue) => {
                setgrille(defaultValue?.name);
                setGridAttributs([]);
                props.handelChangegrilletId(defaultValue?.id);
                dispatch(getAttributsGrid(defaultValue?.id));
                setVisibleOptions([]);
                setHiddenOptions([]);
                setValue([]);
                dispatch(getOneGrilles(defaultValue?.id))
                //dispatch(HandelGrille(defaultValue));
                
              }}
              formatOptionLabel={(country) => (
                <div className="country-option">
                  <span>{country.name}</span>
                </div>
              )}
            />
          </div>

          {/* ---------------agent---------------- */}
          <div>
            <Select
              className="basic-single"
              classNamePrefix="select"
              placeholder={
                client?.firstName
                  ? client?.firstName
                  : "Choisir l'agent à évaluer"
              }
              defaultValue={
                dup ? dataeval?.eval?.agent?.firstName : client?.firstName
              }
              isDisabled={false}
              isLoading={false}
              isClearable={true}
              isRtl={false}
              isSearchable={true}
              name="color"
            /*   value={formik.values.agent}
              onBlur={formik.handleBlur} */
              getOptionValue={(client) => client?.firstName}
              onChange={(defaultValue) => {
                props.handelChangeagentId(defaultValue?.id);
                setagent(defaultValue?.firstName);
              }}
              options={clients.map && clients.map((e) => e)}
              formatOptionLabel={(country, key) => (
                <div className="country-option" key={key}>
                  <img
                    width={20}
                    style={{ borderRadius: "50%", marginRight: "5px" }}
                    src={alice}
                    alt="country-image"
                  />
                  <span>
                    {country.firstName} {country.lastName}
                  </span>
                </div>
              )}
            />
          </div>

       
          <div>
           
            <DatePicker
              popperPlacement="bottom-end"
              className="red-border date-input"
              selected={startDate}
              locale={fr}
              dateFormat="dd/MM/yyyy"
              calendarStartDay={1}
              onChange={(date) => {
                setStartDate(date);
                props.handelChangedate(new Date(date).getTime());
              }}
              filterDate={(date) => {
                return Date.now() > date;
              }}
              placeholderText={
                dup
                  ? new Date(
                      dataeval?.eval?.dateInteraction
                    ).toLocaleDateString()
                  : "jj/mm/aaaa"
              }
              customInput={<ExampleCustomInput />}
            />
          </div>
        </div>
{/*         </form>
 */}        {/* -----------------Compléments-------------- */}

        <div className="vertical-items2">
          <span
            className="left-side_title"
            style={{ marginTop: 10 }}
          >
            Compléments
          </span>
          <div>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="Attributs">
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{ padding: "0px 30px", width: "100%" }}
                  >
                    {GridAttributs && GridAttributs.length ? (
                      GridAttributs.map((attribut, index) => {
                        return (
                          <div>
                            <Draggable
                              key={attribut?.id}
                              draggableId={String(attribut?.id)}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{
                                    marginBottom: 10,
                                    backgroundColor: "white",
                                    ...provided.draggableProps.style,
                                  }}
                                >
                                  <div>
                                    <span style={{ padding: "0px 8px" }}>
                                      {attribut?.name}
                                    </span>
                                  </div>
                                  <div>
                                    <Select
                                      key={index}
                                      className="basic-single"
                                      classNamePrefix="select"
                                      placeholder={"Valeurs Attributs"}
                                      isMulti
                                      styles={{
                                        valueContainer: (base) => ({
                                          ...base,
                                          flexWrap: "wrap",
                                          padding: "0 6px",
                                          maxHeight: "100px", 
                                          overflowY: "auto",
                                         
                                        }),
                                        menuList: (styles) => {
                                          return {
                                            ...styles,
                                          };
                                        },
                                      }}
                                      //isDisabled={true}
                                      isLoading={false}
                                    //  styles={selectStyles}
                                      isRtl={false}
                                      isSearchable={true}
                                      name="color"
                                      defaultValue={
                                        attribut?.selectedValues &&
                                        attribut?.selectedValues?.map((v) => v)
                                      }
                                      options={attribut?.ValeurAttribut?.filter(
                                        (v) => v.status == true
                                      ).map((item, index) => ({
                                        value: item.id,
                                        label: item.name,
                                        //     attribut : attribut,
                                        attributId: attribut?.id,
                                      }))}
                                      onChange={(selectedoptions) =>
                                        handleSelectedValuesChange(
                                          selectedoptions,
                                          attribut?.id
                                        )
                                      }
                                      formatOptionLabel={formatOptionLabel}
                                    />
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          </div>
                        );
                      })
                    ) : (
                      <div></div>
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSide;
